module.exports = __webpack_public_path__ + "static/media/1014917.44428540.jpg";